const formatCardCSC = (value) =>
  value
    .replace(/\s+/g, '')
    .replace(/[^0-9]/gi, '')
    .substr(0, 4);

export default formatCardCSC;
